import { Navigate } from 'react-router-dom'
import { useSession } from 'gunsi-auth'
import { useEvenI18n } from '../i18n/even.js'

const AUTH_PORTAL = import.meta.env.VITE_AUTH_PORTAL_URL
  ?? `${location.protocol}//${location.hostname}:5174`
const GP_LOGO_URL = `${AUTH_PORTAL}/gp_logo_2d.png`

export function Home() {
  const { session, loading } = useSession()
  const t = useEvenI18n()

  if (!loading && session) return <Navigate to="/groups" replace />

  const year = new Date().getFullYear() + 10000

  return (
    <main className="home">
      <div className="home-inner">
        <h1 className="home-big-title">
          <span className="home-big-line">
            <span className="home-big-hero" aria-hidden="true" />
            <span className="home-big-text">ven</span>
          </span>
        </h1>
        <p className="home-sub">{t.home.tagline}</p>
        {!loading && (
          <a
            href={`${AUTH_PORTAL}/login?next=${encodeURIComponent(window.location.href)}`}
            className="home-cta"
          >
            {t.home.cta}
          </a>
        )}
      </div>
      <footer className="home-footer">
        <span>©{year} Gunsi Productions</span>
        <img src={GP_LOGO_URL} alt="Gunsi Productions" />
      </footer>
    </main>
  )
}
